module.exports = __webpack_public_path__ + "img/sankaku_68_red.1eb13318.png";